/**
 * Tabs — shadcn Tabs 어댑터. 기존 TabItem 배열 API 유지.
 *
 * 이 컴포넌트는 탭 네비게이션 바만 렌더링한다 (콘텐츠 패널 없음).
 * 소비자가 value/onChange로 활성 탭을 직접 제어하고 콘텐츠를 별도 렌더링하는 패턴을 유지.
 * size/variant props는 Tailwind 클래스로 매핑해 시각적 동등성을 최대한 보존한다.
 */

import { ReactNode } from 'react'
import {
  Tabs as ShadTabs,
  TabsList,
  TabsTrigger,
} from '@/components/ui/tabs'
import { cn } from './cn'

export interface TabItem {
  key: string
  label: string
  icon?: ReactNode
}

interface TabsProps {
  items: TabItem[]
  value: string
  onChange: (key: string) => void
  size?: 'sm' | 'md'
  /** 시각 스타일 변형 */
  variant?: 'card' | 'minimal' | 'elegant' | 'flush'
  className?: string
}

export function Tabs({ items, value, onChange, size = 'sm', variant = 'card', className }: TabsProps) {
  // size 매핑: sm → text-xs/h-7, md → text-sm/h-9(shadcn 기본)
  const sizeClass = size === 'sm' ? 'h-7 text-xs' : ''

  return (
    <ShadTabs
      value={value}
      onValueChange={onChange}
      className={cn('w-fit', className)}
    >
      <TabsList className={cn(sizeClass)}>
        {items.map((item) => (
          <TabsTrigger
            key={item.key}
            value={item.key}
            className={cn(sizeClass, 'gap-1')}
          >
            {item.icon && <span className="shrink-0">{item.icon}</span>}
            {item.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </ShadTabs>
  )
}
